(() => {
  window.swinger.eventHub.register('dragstart', '.swinger-card__link[draggable]', (e) => {
    const link = window.swinger.eventHub.getTarget(e);

    const card = link.closest('.swinger-card');
    const image = window.swinger.$('.swinger-image__image--default', card)[0];

    const tdWidth = card.matches('.swinger-card--scene,.swinger-card--clip') ? '100%' : '100%'; // used to be 50% and 33%
    const imageWidth = card.matches('.swinger-card--scene,.swinger-card--clip') ? '260' : '260'; // used to be 260 and 170

    const name = link.textContent;
    const { href } = link;
    let src = image.currentSrc;
    try {
      src = image.srcset.match(/http[^\s]+400x[^\s]+/)[0];
    } catch (e) {
      // noop
    }

    // Thunderbird since 127 has this bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1944369
    // Fix is the following: https://stackoverflow.com/questions/59410137/prevent-thunderbird-from-magnifying-image-and-use-it-as-a-link

    const html = `

<!-- Element Start -->
<td class="column" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="${tdWidth}">
  <table border="0" cellpadding="0" cellspacing="0" class="image_block" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
    <tbody>
      <tr>
        <td class="pad" style="padding-bottom:5px;padding-left:5px;padding-right:5px;padding-top:10px;width:100%;">
          <div align="center" class="alignment" style="line-height:10px; text-align: center;">
            <a href="${href}" style="outline:none" target="_blank">
              <img alt="Image" src="${src}" style="vertical-align: bottom; height: auto; border: 0; width: ${imageWidth}px; max-width: 100%;" title="${name}" width="${imageWidth}">
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <table border="0" cellpadding="0" cellspacing="0" class="text_block" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; word-break: break-word;" width="100%">
    <tbody>
      <tr>
        <td class="pad" style="padding-bottom:15px;padding-left:10px;padding-right:10px;padding-top:5px;">
          <div style="font-family: sans-serif">
            <div class="txtTinyMce-wrapper" style="font-size: 14px; mso-line-height-alt: 16.8px; color: #555555; line-height: 1.2; font-family: Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif;">
              <p style="margin: 0; font-size: 14px; text-align: center;"><a href="${href}" style="color: #dc0007; outline:none" target="_blank">${name}</a></p>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</td>
<!-- Element Ende -->

`;

    e.dataTransfer.clearData();
    e.dataTransfer.setData('text/html', html);
    e.dataTransfer.setData('text/plain', html);
  });

  window.swinger.eventHub.register('mouseleave focusout', '.swinger-card, .swinger-card__link', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const card = elem.closest('.swinger-card');
    const link = window.swinger.$('.swinger-card__link', card)[0];

    if (link && link.hasAttribute('aria-label')) {
      const title = link.getAttribute('aria-label');

      link.setAttribute('title', title);
      link.removeAttribute('aria-label');
    }
  });

  window.swinger.eventHub.register('mouseenter focusin', '.swinger-card, .swinger-card__link', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const card = elem.closest('.swinger-card');
    const link = window.swinger.$('.swinger-card__link', card)[0];

    if (link && link.hasAttribute('title')) {
      const title = link.getAttribute('title');

      link.setAttribute('aria-label', title);
      link.removeAttribute('title');
    }
  });
})();
